/**
 * PC_AG_01
 * Importing the component, API and packages
 */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { deleteAppreciation, getAppreciation } from '../../service/PerformanceAPI';
import moment from 'moment';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import { getstatus } from '../../service/WfhAPI';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Popup from '../../components/ConformationPopup/Popup';
import Loader from '../../StaticComponent/Loader';
import { encryptStorage } from '../../constant';

export default function Appreciation() {
    const navigate = useNavigate();
    const { state } = useLocation();
    /**
     * PC_AG_02
     * State variables are created
     */
    const [appreciation, setAppreeciation] = useState([]);
    const [userId, setuserId] = useState();

    const filterData = { start_date: '', end_date: '', domain: '' };
    const [filter, setFilter] = useState(filterData);
    const [userDetails, setUserDetails] = useState({});
    const [appreciationShowMore, setAppreciationShowMore] = useState(10);
    const [showMore, setShowMore] = useState(false);
    const [appreciationId, setAppreeciationId] = useState();
    const [searchName, setSearchName] = useState('');
    const [noData, setNoData] = useState(false);
    const [empSort, setEmpSort] = useState(false);
    const [dateSort, setDateSort] = useState(false);
    const [domainSort, setDomainSort] = useState(false);
    const [bySort, setBySort] = useState(false);

    const [filterCheck, setFilterCheck] = useState(false);
    const [searchCheck, setSearchCheck] = useState(false);
    const [domain, setDomain] = useState();
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    /**
     * PC_AG_03,PC_AG_12
     * useEffect is invoked andthen loadAppreciationData function is called
     */
    useEffect(() => {
        let toastCheck = sessionStorage.getItem('appreciationToast');
        if (toastCheck == 'inserted' || toastCheck == 'updated') {
            setToastColor('green');
            if (toastCheck == 'inserted') {
                setToastPara('Appreciation is Published');
                setToastValue('Successfully Published');
            }
            if (toastCheck == 'updated') {
                setToastPara('Appreciation is Republished');
                setToastValue('Successfully Republished');
            }
            setinsertToast(true);
            sessionStorage.removeItem('appreciationToast');
        }
        // ;
        if (encryptStorage.getItem('groupid') == '1' || encryptStorage.getItem('groupid') == '2') {
            let userRole = encryptStorage.getItem('role');
            let userId = encryptStorage.getItem('employeeId');
            userDetails.roleId = userId;
            userDetails.role = userRole;
            userDetails.domain = encryptStorage.getItem('department');

            setuserId(userId);
            setUserDetails({ role: userRole, roleId: userId });

            getstatus().then((res) => {
                setDomain(res.data.domain);
            });
            loadAppreciationData();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    /**
     * PC_AG_04
     * getAppreciation function is invoked to retrieve the data
     * then response is set in state variable
     */
    const loadAppreciationData = async () => {
        setbreadCrumbsData(
            userDetails.role == 'Team Member'
                ? [
                    { title: 'Dashboard', path: '/overview', isActive: true },
                    { title: 'How Do I', path: '', isActive: true },
                    { title: 'Appreciation', path: '/appreciation', isActive: false },
                ]
                : [
                    { title: 'Dashboard', path: '/overview', isActive: true },
                    { title: 'Team Member', path: '', isActive: true },
                    { title: 'Appreciation', path: '/appreciation', isActive: false },
                ]
        );

        let obj = { role: userDetails.role, roleId: userDetails.roleId, limit: appreciationShowMore, search: searchName };

        let appreciationResponse = await getAppreciation(obj);

        setAppreeciation(appreciationResponse?.data?.ResponseData != 'No data found' ? appreciationResponse.data.ResponseData : []);
        let noDataValue = appreciationResponse.data.ResponseData.length === 0 ? true : false;
        setNoData(noDataValue);

        let count = appreciationResponse.data.countResult;
        let result = count / appreciationShowMore;
        setShowMore(result <= 1 ? false : true);
    };

    const infoForShowMore = (countResult, countToDivid) => {
        let count = countResult;
        let result = count / countToDivid;
        setShowMore(result <= 1 ? false : true);
    };

    /**
     * PC_AG_20
     * @param {*} id - passed as parameter for editing particular appreciation
     * using navigate, redirect appreciationForm
     */

    const editClicked = (id) => {
        navigate(`/appreciationform/${id}`, {
            state: { appreciationId: id },
        });
    };

    /**
     * PC_AG_13,PC_AG_19
     * deleteClicked function is invoked when delete button is clicked
     * deleteAppreciation function is called to delete the appreciation
     * loadAppreciationData function invoked after successfull response from backend
     */

    const deleteClicked = async () => {
        setIsLoading(false);
        let obj = {
            appreciationId: appreciationId,
        };

        let deleteInfo = await deleteAppreciation(obj);
        if (deleteInfo.data.ResponseData == 'Successfully deleted') {
            setIsLoading(true);
            loadAppreciationData();
        }
    };

    /**
     * PC_AG_25
     * @param {*} order - order in which the sort has to be done
     * @param {*} columnName - column to be sorted
     * getAppreciation function is called aand response is stored and rendered
     */
    const sortClicked = async (order, columnName) => {
        let sortColumn = columnName;
        let sortBy =
            columnName === 'name'
                ? setEmpSort(!empSort)
                : columnName === 'date'
                    ? setDateSort(!dateSort)
                    : columnName === 'domain'
                        ? setDomainSort(!domainSort)
                        : setBySort(!bySort);

        //
        let obj =
            filterCheck || searchCheck
                ? {
                    sortColumn: columnName,
                    sortType: order,
                    limit: appreciationShowMore,
                    roleId: userDetails.roleId,
                    role: userDetails.role,
                    start_date: filter.start_date,
                    end_date: filter.end_date,
                    domain: filter.domain,
                    search: searchName,
                }
                : {
                    sortColumn: columnName,
                    sortType: order,
                    roleId: userDetails.roleId,
                    role: userDetails.role,
                    limit: appreciationShowMore,
                };
        let response = await getAppreciation(obj);
        setAppreeciation(response?.data?.ResponseData.length > 0 ? response.data.ResponseData : null);
        let noDataValue = response?.data?.ResponseData.length <= 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(response.data?.countResult, appreciationShowMore);
        }
    };

    /**
     * PC_AG_10,PC_AG_11 and PC_AG_19
     * when appreciation state variable changes
     * appreciationBind function is invoked and rendered
     */
    const appreciationBind = () => {
        try {
            return appreciation.map((eachAppreciation) => {
                return (
                    <tr className="hive-table-data regular-text align-middle">
                        <td>
                            <div className="d-flex align-items-center">
                                <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                                <div className="ms-2">
                                    <a className="table-name-style mb-0">{eachAppreciation.appreciation_to}</a>
                                </div>
                            </div>
                        </td>
                        {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' ? <td>{eachAppreciation.domain}</td> : null}
                        <td>{eachAppreciation.appreciation_by}</td>
                        <td className="text-truncate" style={{ 'max-width': '100px' }} title={eachAppreciation.appreciation}>
                            {eachAppreciation.appreciation}
                        </td>
                        <td>
                            {moment(eachAppreciation.start_date).format('MMM-DD')} -
                            {moment(eachAppreciation.end_date).format('MMM-DD, YYYY')}
                        </td>
                        <td>
                            {userId == eachAppreciation.created_by_id ? (
                                <>
                                    <span
                                        className="me-3"
                                        onClick={() => {
                                            editClicked(eachAppreciation.id);
                                        }}
                                    >
                                        <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                    </span>
                                    <span
                                        onClick={() => {
                                            setAppreeciationId(eachAppreciation.id);
                                        }}
                                    >
                                        <img
                                            data-bs-toggle="modal"
                                            data-bs-target="#logout"
                                            src="/Images/hive-delete-icon.svg"
                                            alt="delete"
                                            data-bs-placement="bottom"
                                            title="delete "
                                        />
                                    </span>
                                </>
                            ) : (
                                <span
                                    className="text-decoration-none table-link-clr"
                                    onClick={() => {
                                        navigate('/empappreciation', { state: { id: eachAppreciation.id, show: true } });
                                    }}
                                >
                                    View
                                </span>
                            )}
                        </td>
                    </tr>
                );
            });
        } catch (error) { }
    };

    /**
     * PC_AG_21
     * @param {*} e - has event to change the value in state
     */
    const filterOnChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    /**
     * PC_AG_22
     * UserClicks apply filter button in filter button
     * getAppreciation function is called response is set to state variable
     */
    const appreciationFilterClick = async () => {
        setAppreciationShowMore(10);
        let filterCount = 10;
        setFilterCheck(true);
        let obj = {
            role: userDetails.role,
            roleId: userDetails.roleId,
            limit: filterCount,
            start_date: filter.start_date,
            end_date: filter.end_date,
            domain: filter.domain,
            search: searchName,
        };
        let appreciationResponse = await getAppreciation(obj);
        ////
        setAppreeciation(appreciationResponse?.data?.ResponseData.length > 0 ? appreciationResponse.data.ResponseData : []);
        let noDataValue = appreciationResponse.data.ResponseData.length === 0 ? true : false;
        setNoData(noDataValue);
        infoForShowMore(appreciationResponse?.data?.countResult, filterCount);
    };

    /**
     * PC_AG_24
     * UserClicks filter clear in filter button
     * filter data is set to empty
     */
    const appreciationClearClick = () => {
        setFilter(filterData);
        loadAppreciationData();
    };

    /**
     * PC_AG_23
     * user when clicks showmore button is appreciation grid
     * apreciationSShowmore state variable is change and getAppreciation API iscalled and response is stored in appreciation state variable
     */
    const showMoreAppreciation = async () => {
        if (filterCheck || searchCheck) {
            let filterCount = appreciationShowMore;

            filterCount += 10;
            setAppreciationShowMore(filterCount);
            let obj = {
                role: userDetails.role,
                roleId: userDetails.roleId,
                limit: filterCount,
                start_date: filter.start_date,
                end_date: filter.end_date,
                domain: filter.domain,
                search: searchName,
            };
            let appreciationResponse = await getAppreciation(obj);
            setAppreeciation(appreciationResponse?.data?.ResponseData);
            infoForShowMore(appreciationResponse?.data?.countResult, filterCount);
        } else {
            ////
            let loadData = appreciationShowMore + 10;
            setAppreciationShowMore(loadData);
            let obj = { role: userDetails.role, roleId: userDetails.roleId, limit: loadData };
            let appreciationResponse = await getAppreciation(obj);
            setAppreeciation(appreciationResponse?.data?.ResponseData);
            infoForShowMore(appreciationResponse?.data?.countResult, loadData);
        }
    };

    /**
     * PC_AG_26
     * event is passed to check whether user press enter key
     */
    const handleSearchKeyDown = (e) => {
        if (e.charCode == 13) {
            //
            searchByName();
        }
    };

    /**
     * PC_AG_26
     * when user press search icon in searchbox searchByName method is called and the set appreciationShowMore to 0 and shomoreAppreciation is called
     */
    const searchByName = async () => {
        setFilterCheck(filterCheck ? false : false);
        setSearchCheck(true);

        // setAppreciationShowMore(0);
        // showMoreAppreciation();
        let limit = 10;
        let data = {
            roleId: userDetails.roleId,
            role: userDetails.role,
            limit: limit,
            search: searchName,
            start_date: filter.start_date,
            end_date: filter.end_date,
            domain: filter.domain,
        };

        let appreciationResponse = await getAppreciation(data);

        setAppreeciation(appreciationResponse.data.ResponseData != 'No data found' ? appreciationResponse.data.ResponseData : null);
        let noDataValue = appreciationResponse.data.ResponseData.length === 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(appreciationResponse.data?.countResult, limit);
        }
    };

    /**
     * PC_AG_12
     * @returns binds list of domain in filter dropDown
     */
    const binddomain = () => {
        return domain?.map((res) => {
            return <option value={res.domain}>{res.domain}</option>;
        });
    };

    return (
        <div>
            <Popup
                deleteData={() => {
                    deleteClicked();
                }}
                para={`Are you sure to delete this appreciation`}
            />
            <Loader isLoading={isLoading} />
            {insertToast ? <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} /> : null}
            <div className="container-fluid mt-5">
                <div className="row justify-content-center mt-3">
                    <div className="row ml-10 col-md-11 mt-4">
                        <BreadCrumbs data={breadCrumbsData} />
                    </div>
                    <div className="col-md-11 d-flex align-items-center ">
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="tt-bold mb-0">Appreciation</p>
                        </div>
                        <div className="ms-auto d-flex">
                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Manager' ? (
                                <div className="input-group flex-nowrap search-group me-3">
                                    <input
                                        onChange={(e) => {
                                            setSearchName(e.target.value);
                                        }}
                                        type="search"
                                        className="form-control search-align "
                                        placeholder="Search by Team member"
                                        aria-label="Username"
                                        aria-describedby="addon-wrapping"
                                        onKeyPress={(e) => handleSearchKeyDown(e)}
                                    />
                                    <button
                                        onClick={() => {
                                            searchByName();
                                        }}
                                        className="input-group-text btn btn-search-custom "
                                        id="addon-wrapping"
                                    >
                                        <img src="/Images/search-icon.svg" alt="search-icon" />
                                    </button>
                                </div>
                            ) : null}
                            {/*Filter Section Starts Here*/}
                            <div className="dropdown">
                                <button
                                    className="advanced-filter-button me-3 medium-text custom-fil-btn "
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                    Filter
                                </button>
                                <div
                                    className="dropdown-menu px-3 advanced-filter-panel custom-filter-app"
                                    aria-labelledby="dropdownMenuButton1"
                                >
                                    <div className="row">
                                        <div className="col-md-12 py-2 border-0 mb-1">
                                            <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                            <button
                                                type="button"
                                                className="btn-close float-end close-filter"
                                                data-bs-dismiss="advanced-filter"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="col-md-12 ">
                                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' ? (
                                                <div className="col-md-6 mb-3 ">
                                                    <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                        Domain
                                                    </label>
                                                    <select
                                                        className="form-select hive-form-select mt-2"
                                                        name="domain"
                                                        onChange={(e) => {
                                                            filterOnChange(e);
                                                        }}
                                                        value={filter.domain}
                                                        aria-label="Default select example2"
                                                        id="Approval_status"
                                                    >
                                                        <option selected value="">
                                                            Select
                                                        </option>
                                                        {binddomain()}
                                                    </select>
                                                </div>
                                            ) : null}
                                            <div className="col-md-12 pb-2 border-0 ">
                                                <span className="font-14 semibold-text filter-title">Date Range</span>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="fromrange">
                                                        From
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="fromrange"
                                                        name="start_date"
                                                        value={filter.start_date}
                                                        onChange={(e) => {
                                                            filterOnChange(e);
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label hive-form-label" htmlFor="forange">
                                                        To
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control hive-form-control"
                                                        id="forange"
                                                        name="end_date"
                                                        value={filter.end_date}
                                                        onChange={(e) => {
                                                            filterOnChange(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 my-3 d-flex justify-content-end">
                                            <button
                                                className="btn hive-btn-secondary me-3"
                                                onClick={() => {
                                                    appreciationClearClick();
                                                }}
                                            >
                                                Clear
                                            </button>
                                            <button
                                                className="btn hive-btn-primary"
                                                onClick={() => {
                                                    appreciationFilterClick();
                                                }}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*Filter Section Ends Here*/}
                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' || userDetails.role == 'Manager' ? (
                                <Link style={{ textDecoration: 'none' }} to={'/appreciationform'}>
                                    <button className="btn hive-btn-primary">
                                        <img src="/Images/hive-add-icon.svg" className="me-2" />
                                        New Appreciation
                                    </button>
                                </Link>
                            ) : null}
                        </div>
                    </div>
                    {/*Tab Content Starts Here*/}
                    <div className="col-md-11">
                        <div className="tab-content" id="pills-tabContent">
                            {/*All Leave Request Section Starts Here*/}
                            <div
                                className="tab-pane fade show active mt-4"
                                id="all_leave_request"
                                role="tabpanel"
                                aria-labelledby="all_leave_request_tab"
                            >
                                <div className="table-responsive rounded-3">
                                    <table className="table bg-white hive-grid table-borderless ">
                                        <thead className="hive-table-head">
                                            <tr>
                                                <th className="bold-text font-12">
                                                    Team Members Name
                                                    <span>
                                                        {empSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'name');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort ps-1"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'name');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort ps-1"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' ? (
                                                    <th className="bold-text font-12">
                                                        Domain
                                                        <span>
                                                            {domainSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'domain');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort ps-1"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'domain');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort ps-1"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                ) : null}
                                                <th className="bold-text font-12">
                                                    Appreciation By
                                                    {userDetails.role === 'Manager' ? (
                                                        <span>
                                                            {bySort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'by');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort ps-1"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'by');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort ps-1"
                                                                />
                                                            )}
                                                        </span>
                                                    ) : null}
                                                </th>
                                                <th className="bold-text font-12">
                                                    Appreciation<span className="ps-2"></span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    Date Range
                                                    {dateSort ? (
                                                        <img
                                                            onClick={() => {
                                                                sortClicked('desc', 'date');
                                                            }}
                                                            src="/Images/Sort-up.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort ps-1"
                                                        />
                                                    ) : (
                                                        <img
                                                            onClick={() => {
                                                                sortClicked('asc', 'date');
                                                            }}
                                                            src="/Images/sort-icon.svg"
                                                            alt="Sorticon"
                                                            className="hive-table-sort ps-1"
                                                        />
                                                    )}
                                                </th>
                                                <th className="bold-text font-12">
                                                    Action<span className="ps-2"></span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{noData ?
                                            <tr>
                                                <td colSpan={6}>
                                                    <div className="text-center w-100">
                                                        <img
                                                            src="/Images/nodatafound.png"
                                                            alt="nodatafound"
                                                            className="nofeedbackimg-sty custom-nodata-found"
                                                        />
                                                        <h2 className="tt-bold font-15 text-center">No Appreciation Found</h2>
                                                    </div>
                                                </td>
                                            </tr>
                                            : appreciationBind()}</tbody>
                                    </table>

                                </div>
                                <div className="text-center pb-3">
                                    {showMore ? (
                                        <button
                                            className="btn show-more-btn"
                                            onClick={() => {
                                                showMoreAppreciation();
                                            }}
                                        >
                                            Show More
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                            {/*All Leave Request Section Ends Here*/}
                            {/*My Leave Request Section Starts Here*/}
                            <div
                                className="tab-pane fade show active"
                                id="my_leave_request"
                                role="tabpanel"
                                aria-labelledby="my_leave_request_tab"
                            ></div>

                            <div
                                className="tab-pane fade show active"
                                id="wfh_request"
                                role="tabpanel"
                                aria-labelledby="wfh_request_tab"
                            ></div>

                            <div
                                className="tab-pane fade show active"
                                id="my_wfh_request"
                                role="tabpanel"
                                aria-labelledby="my_wfh_request_tab"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
